import { ManagerData } from 'api/types/data';
import {
  ObjectSchema,
  string,
  object,
  TypedForm,
  date,
  FormErrors as FormErrorsBase,
} from 'libs/form';
import { Maybe } from 'types/maybe';

export interface AccountCodesFormType {
  accountCodes: {
    code?: string | null;
    personalAccountNumber?: string | null;
    personalAccountOpeningDate?: Date | null;
    personalAccountClosingDate?: Date | null;
    personalAccountFreezingDate?: Date | null;
    centralDepositoryAccountNumber?: string | null;
    centralDepositoryAccountNumberOpeningDate?: Date | null;
    manager?: Maybe<ManagerData>;
  };
}

export const accountCodesSchema: ObjectSchema<AccountCodesFormType> = object({
  accountCodes: object({
    code: string().nullable(),
    personalAccountNumber: string().max(200).nullable(),
    personalAccountOpeningDate: date().nullable(),
    centralDepositoryAccountNumber: string().nullable(),
    centralDepositoryAccountNumberOpeningDate: date().nullable(),
    manager: object({
      id: string().required(),
      name: string().required(),
    })
      .nullable()
      .default(null),
    personalAccountClosingDate: date().nullable(),
    personalAccountFreezingDate: date().nullable(),
  }).default({}),
});

export const { Field, Form, useFormContext, Submit } =
  TypedForm<AccountCodesFormType>();

export type FormErrors = FormErrorsBase<AccountCodesFormType>;
